import React from "react";
import { Router } from "@reach/router"
import styles from "./App.module.scss";
// Pages for Router
import Login from "./pages/Login";
import Operator from "./pages/Operator";
import Supervisor from "./pages/Supervisor";
import Maintenance from "./pages/Maintenance";
import Management from "./pages/Management";
import Admin from "./pages/Admin";
import Checklist from "./components/Checklist";
import SubmitLoad from "./pages/Operator/SubmitLoad";
import ReportAProblem from "./pages/Operator/ReportAProblem/ReportAProblem";
import PrivateRoute from "./routes/PrivateRoute";
import MaintenanceReport from "./pages/Maintenance/MaintenanceReport";

// Data
import checklistData from "./data/checklistdata.js";

//Providers
import { UserProvider } from "./context/userContext";

//3rd party
import * as FullStory from '@fullstory/browser';
const fullstoryOrgId = '12R89A'
FullStory.init({ orgId: fullstoryOrgId});

const App = () => {

  return (
    <>
      <UserProvider fullstory={FullStory}>
        {/* <Header /> */}
        <Router className={styles.fullWidth}>
          <Login path="/" />
          <PrivateRoute path="/">
            <Operator path="/operator/*" />
            <Supervisor path="/supervisor/*" />
            <Maintenance path="/maintenance/*" />
            <MaintenanceReport path="/maintenance-report" />
            <Management path="/management/*" />
            <Admin path="/admin/*" />
            <Checklist path="/Checklist" checklistData={checklistData} />
            <SubmitLoad path="/SubmitLoad" />
            <ReportAProblem path="/ReportAProblem" />
          </PrivateRoute>
        </Router>
      </UserProvider>
    </>
  );
}

export default App;
